import { render, staticRenderFns } from "./GiveAwayModal.vue?vue&type=template&id=77ba39d4&scoped=true"
import script from "./GiveAwayModal.vue?vue&type=script&lang=ts"
export * from "./GiveAwayModal.vue?vue&type=script&lang=ts"
import style0 from "./GiveAwayModal.vue?vue&type=style&index=0&id=77ba39d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ba39d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ba39d4')) {
      api.createRecord('77ba39d4', component.options)
    } else {
      api.reload('77ba39d4', component.options)
    }
    module.hot.accept("./GiveAwayModal.vue?vue&type=template&id=77ba39d4&scoped=true", function () {
      api.rerender('77ba39d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/give-away/components/GiveAwayModal.vue"
export default component.exports